import userRoles from '@/utils/constants/userRoles';
const pilotPlanRoles = [userRoles.maestro, userRoles.director, userRoles.AuxiliarAdministrativoEscolar];

export default pilotPlanRoles;
